module.exports = __webpack_public_path__ + "bbf0fa0914417037ef13ff14845eba89.png";